import { FormBase } from 'core/components';

export default class FacilityOrderTemplatePatientCreateForm extends FormBase {
    constructor(hooks) {      
        super(hooks);
    }

    setup() {
        
        return {
            fields: [
                {
                    name: 'firstName',
                    label: 'IMPORT_PATIENT.CREATE.FIRST_NAME_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.FIRST_NAME_PLACEHOLDER',
                    rules: 'required|string'
                },
                {
                    name: 'lastName',
                    label: 'IMPORT_PATIENT.CREATE.LAST_NAME_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.LAST_NAME_PLACEHOLDER',
                    rules: 'required|string'                    
                },
                {
                    name: 'gender',
                    label: 'IMPORT_PATIENT.CREATE.GENDER_LABEL',
                    placeholder: 'Select Gender',     
                    rules: 'required'              
                },
                {
                    name: 'dateOfBirth',
                    label: 'IMPORT_PATIENT.CREATE.DATE_OF_BIRTH_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.DATE_OF_BIRTH_PLACEHOLDER',   
                    //rules: 'required'  
                    rules: ['regex:/^(0[0-9]|[0-9]|(1)[0-2])/(0[0-9]|[0-9]|[1-2][0-9]|(3)[0-1])/((19|20)[\\d]{2})$/g', 'required']
                },
                {
                    name: 'contactPhone',
                    label: 'IMPORT_PATIENT.CREATE.PHONE_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.PHONE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'contactState',
                    label: 'IMPORT_PATIENT.CREATE.STATE_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.STATE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'ssn',
                    label: 'SSN',
                    placeholder: 'Enter SSN',
                    rules: ['string', 'max:11', 'regex:^([0-9]{3}-[0-9]{2}-[0-9]{4})$']
                },
                {
                    name: 'contactRelationship',
                    label: 'Relationship',
                    placeholder: 'Select Relationship',
                    rules: 'string'                    
                },
                {
                    name: 'contactFirstName',
                    label: 'IMPORT_PATIENT.CREATE.FIRST_NAME_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.FIRST_NAME_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'contactLastName',
                    label: 'IMPORT_PATIENT.CREATE.LAST_NAME_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.LAST_NAME_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'contactAddressLine1',
                    label: 'Address Line 1',
                    placeholder: 'Enter Address Line 1',
                    rules: 'string'
                },
                {
                    name: 'contactAddressLine2',
                    label: 'Address Line 2',
                    placeholder: 'Enter Address Line 2',
                    rules: 'string'
                },
                {
                    name: 'contactCity',
                    label: 'City',
                    placeholder: 'Enter City',
                    rules: 'string'
                },
                {
                    name: 'contactCountry',
                    label: 'Country',
                    placeholder: 'Enter Country',
                    rules: 'string'
                },
                {
                    name: 'contactPostalCode',
                    label: 'Postal Code',
                    placeholder: 'Enter Postal Code',
                    rules: 'numeric'
                },
                {
                    name: 'height',
                    label: 'Height',
                    placeholder: 'Enter Height',
                    rules: 'numeric'                    
                },
                {
                    name: 'weight',
                    label: 'Weight',
                    placeholder: 'Enter Weight',
                    rules: 'numeric'                    
                },
                {
                    name: 'primaryInsuranceName',
                    label: 'Insurance',
                    placeholder: 'Select Insurance Name'                   
                },
                {
                    name: 'primaryInsurancePolicyNumber',
                    label: 'Insurance Policy Number',
                    placeholder: 'Enter Insurance Policy Number'           
                },
                {
                    name: 'primaryInsuranceGroupNumber',
                    label: 'Insurance Group Number',
                    placeholder: 'Enter Insurance Group Number'                   
                },
                {
                    name: 'primaryInsuranceStartDate',
                    label: 'Start Date',
                    placeholder: ''
                },
                {
                    name: 'oldPrimaryInsuranceName',
                    label: 'Insurance',
                    placeholder: 'Select Insurance Name'                   
                },
                {
                    name: 'oldPrimaryInsurancePolicyNumber',
                    label: 'Insurance Policy Number',
                    placeholder: 'Enter Insurance Policy Number'           
                },
                {
                    name: 'oldPrimaryInsuranceStartDate',
                    label: 'Start Date',
                    placeholder: ''                
                },
                {
                    name: 'oldPrimaryInsuranceEndDate',
                    label: 'End Date',
                    placeholder: ''                
                },
                {
                    name: 'secondaryInsuranceEndDate',
                    label: 'End Date',
                    placeholder: ''                
                },
                {
                    name: 'secondaryInsuranceName',
                    label: 'Insurance',
                    placeholder: 'Select Insurance Name'                   
                },
                {
                    name: 'secondaryInsurancePolicyNumber',
                    label: 'Insurance Policy Number',
                    placeholder: 'Enter Insurance Policy Number'                   
                },
                {
                    name: 'secondaryInsuranceGroupNumber',
                    label: 'Insurance Group Number',
                    placeholder: 'Enter Insurance Group Number'                   
                },
                {
                    name: 'secondaryInsuranceStartDate',
                    label: 'Start Date',
                    placeholder: ''                  
                },
                {
                    name: 'diagnosisCodes',
                    label: 'Diagnosis Codes',
                    placeholder: 'Select Diagnosis Codes'
                },
                {
                    name: 'subCategoryId',
                    label: 'Sub Category',
                    placeholder: 'Select Sub Category',
                    rules: 'required' 
                },
                {
                    name: 'doc',
                    label: 'Ordering Doctor',
                    placeholder: 'Select Ordering Doctor',
                    // rules: 'required' ,
                },
                {
                    name: 'orderingDoctor',
                    label: 'Ordering Doctor',
                },
                {
                    name: 'orderingDoctorId',
                    label: 'Ordering Doctor Id',
                }
            ],
        };
    }
}
